/* eslint-disable import/no-named-as-default */
import React, { Component, Fragment, ReactNode } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Timeline from "../../Charts/Timeline";
import AnalyticsWidgetLoading from "../../shared/loaders/AnalyticsWidgetLoading";
import { Wrapper } from "../styles/charts-styles";
import { ChartTitle } from "../styles/employer-analytics-styles";
import ReactTooltip from "react-tooltip";

export interface IJobSuccessFeeProps {
  jobSuccessFee: {
    months?: Date[];
    values?: number[];
  };
  jobSuccessFeeWidgetLoader: boolean;
}

export class JobSuccessFee extends Component<IJobSuccessFeeProps> {
  static propTypes = {
    jobSuccessFee: PropTypes.shape({
      months: PropTypes.arrayOf(PropTypes.instanceOf(Date)),
      values: PropTypes.arrayOf(PropTypes.number),
    }),
    jobSuccessFeeWidgetLoader: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    jobSuccessFee: {
      months: [],
      values: [],
    },
  };

  render(): ReactNode {
    const { jobSuccessFee, jobSuccessFeeWidgetLoader } = this.props;

    const jobSuccessFeeOptions = {
      series: [
        {
          name: "Success Fee %",
          data: jobSuccessFee.values,
        },
      ],
      options: {
        height: 350,
        colors: ["#402680"],

        chart: {
          type: "line",
          offsetY: -5,
          zoom: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        stroke: {
          width: [1],
          curve: "straight",
        },
        markers: {
          size: 5,
          radius: 5,
          shape: "circle",
        },

        tooltip: {
          x: {
            formatter: function (value) {
              const date = new Date(value);
              return date.toLocaleString("default", { month: "short" });
            },
          },

          y: [
            {
              title: {
                formatter: (val: string) => val,
              },
            },
          ],
        },
        xaxis: {
          type: "datetime",
          categories: jobSuccessFee.months.map((date) => date.getTime()),
          title: {
            text: "Time",
          },
        },
        yaxis: {
          title: {
            text: "Success Fee %",
          },
        },
        legend: {
          offsetY: 5,
          tooltipHoverFormatter: (
            val: string,
            opts: {
              // I've typed the opts manually because ApexCharts seem to have
              // typed this as 'any' which our lint config doesn't like
              // (at the time of writing, anyway) see
              // https://github.com/apexcharts/apexcharts.js/blob/master/types/apexcharts.d.ts#L744
              w: {
                globals: { series: number[][] };
              };
              seriesIndex: number;
              dataPointIndex: number;
            }
          ) => {
            const value = `${val} - ${
              opts.w.globals.series[opts.seriesIndex][opts.dataPointIndex]
            } `;
            return value;
          },
        },
      },
    };
    // console.log(spendPerSectorOptions);

    return (
      <Fragment>
        <Wrapper
          className="animated fadeIn delay-5"
          id="job-success-fee-widget"
        >
          <AnalyticsWidgetLoading
            text="Updating..."
            active={jobSuccessFeeWidgetLoader}
          />

          <Timeline
            graphOptions={jobSuccessFeeOptions}
            dataTestId="job-success-fee-chart"
          />
          <ChartTitle
            marginBottom={20}
            data-test-id="job-success-fee-title"
            data-tip="Average placement fee (%) attached to role postings."
            data-for="job-success-fee-title-tooltip"
          >
            <ReactTooltip
              type="dark"
              aria-haspopup="true"
              id="job-success-fee-title-tooltip"
              className="tooltip-max-width"
            />
            Average Placement Fee %
          </ChartTitle>
        </Wrapper>
      </Fragment>
    );
  }
}

interface IReduxState {
  employerAnalytics: {
    jobPerformanceData: {
      jobSuccessFee: {
        months: Date[];
        values: number[];
      };
    };
    jobSuccessFeeWidgetLoader: boolean;
  };
}

const mapStateToProps = (state: IReduxState) => ({
  jobSuccessFee: state.employerAnalytics.jobPerformanceData.jobSuccessFee,
  jobSuccessFeeWidgetLoader: state.employerAnalytics.jobSuccessFeeWidgetLoader,
});

export default connect(mapStateToProps, {})(JobSuccessFee);
